import { create } from 'zustand'

/**
 * Canvas-side mirror of the active process capability layers for the
 * diagram currently open in the editor. Lets per-node Konva overlays
 * (GrcBadges) and the selection inspector gate on the Compliance layer
 * without each one resolving the folder config independently.
 *
 * Default `complianceActive: true` — overlays render as before until a
 * *process* folder explicitly sets it false. Non-process diagrams
 * (network/cloud reuse GrcBadges) never set it false, so they are
 * unaffected. Fed once by `ProcessCanvasLayerSync`.
 *
 * See docs/product/process-user-journey.md §6 (canvas GRC overlay gate).
 */
interface ProcessCanvasLayerState {
  complianceActive: boolean
  setComplianceActive: (active: boolean) => void
}

export const useProcessCanvasLayerStore = create<ProcessCanvasLayerState>((set) => ({
  complianceActive: true,
  setComplianceActive: (active) =>
    set((s) => (s.complianceActive === active ? s : { complianceActive: active })),
}))
